module.exports = __webpack_public_path__ + "img/Banner.81cfa9ef.png";